<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card-title>
        <h1 class="headline mb-1">Rubricas</h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialogForm = true">Crear</v-btn>
        </v-card-title>
        <v-row>
          <v-col  
            md="3" dark
            v-for="(rubrica_, r1) in array_rubricas"
            v-if="rubrica_.tipo == 'Imagen'"
            >
            <v-card
              :class="`firmas firma_${rubrica_.id}`"
              :hover="false"
              class="mx-auto">
              <div style="height: 100px; overflow: hidden;">
                <img :src="rubrica_.base_64" v-if="rubrica_.tipo == 'Imagen'">
              </div>
              <v-card-subtitle class="pb-0">
                {{rubrica_.id}} - {{rubrica_.nombre}}
              </v-card-subtitle>
              <v-card-actions>
                <small>{{rubrica_.tipo}}</small>
                <v-spacer></v-spacer>
                <v-btn small @click="dialog=true;selected_id=rubrica_.id;"><v-icon left>delete</v-icon>Eliminar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
          
        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline"></v-card-title>
            <v-card-text>Desea eliminar el item {{selected_id}}?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
              <v-btn color="green darken-1" text @click="dialog = false;eliminar();">Si</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <ModalNuevaRubrica 
          v-if="dialogForm"
          :show_modal="dialogForm"
          v-on:rubrica-to-parent="onRubricaBack">
        </ModalNuevaRubrica>

        <v-snackbar v-model="notificacion_exito">
          {{ texto_notificacion }}
          <v-btn color="pink"
            text
            @click="notificacion_exito = false;">
            Cerrar
          </v-btn>
        </v-snackbar>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
  import axios from "axios";
  import ModalNuevaRubrica from '@/components/documento/ModalNuevaRubrica.vue'; 

  export default {
    components: { 
      ModalNuevaRubrica,
    },
    data () {
      return {
          dialog: false,
          selected_id: 0,
          notificacion_exito: false,
          texto_notificacion: '',
          headers: [
            { text: 'Id', align: 'start',  value: 'id' },
            { text: 'Nombre',value: 'nombre' },
            { text: 'Tipo', value: 'tipo' },          
            { text: 'Accion', value: 'action' }
          ],
          array_rubricas: [],
          dialogForm: false,
          validForm: true,
          nombre: '',
          font_size:8,
          base_64: '',
          color:'',
          texto: '',
          tipo: '',
          errorMessages: '',
          Id: '0',
          rules: {
            required: value => !!value || 'Campo Requerido.',
            positivo_mayor_cero: value =>  0 < Number(value) || 'Campo debe ser mayor a cero'
          },
          rules_files: [
            value => !value || value.size < 2000000 || 'El tamaño debe ser menor a 2 MB!',
          ],
          items_tipo: ['Imagen', 'Texto'],
          items_color:[
            {'item': 'Rojo', "value": 'red'},
            {'item': 'Azul', "value": 'blue'},
            {'item': 'Negro', "value": '#000'},
            {'item': 'Verde', "value": 'green'},
          ],
        }
    },
    mounted() {
      console.log("Mounted");
      this.getRubricas();
    },
    methods: {
      eliminar() {
        console.log("Deleting Item id :" + this.selected_id);
        this.$store.dispatch('SET_OVERLAY');
        console.log('/Rubricas/Eliminar?id=' + this.selected_id);
        let getuser = axios.delete('/Rubricas/Eliminar?id=' + this.selected_id ,  { 'headers': this.$store.state.user.headers })
        return getuser.then((callback) => {
          let resultado = callback.data;
          this.texto_notificacion = 'Operacion finalizada con exito';
          this.notificacion_exito = true;

          console.log('Eliminando el item : ' + this.selected_id);
          this.$store.dispatch('UNSET_OVERLAY');
          this.array_rubricas.splice(this.array_rubricas.findIndex(e => e.id == this.selected_id), 1);

        }).catch((error) => {
          this.$store.dispatch('UNSET_OVERLAY');
          this.texto_notificacion = 'Error al realizar la operacion : ' + error;
          this.notificacion_exito = true;
          console.log(error);
        });
      },
      editar(item) {               
        this.$router.push({ name: "edit_rubrica", params: { "Id": item.id } });
      },
      getRubricas() {
        this.$store.dispatch('SET_OVERLAY');
        let getRubricas = axios.get('/Rubricas/Listar', { 'headers': this.$store.state.user.headers });
        return getRubricas.then((callback) =>
        {                     
          this.array_rubricas = callback.data;
          this.$store.dispatch('UNSET_OVERLAY');
        }).catch((error) => {
            this.texto_notificacion = error;
            this.notificacion_exito = true;
            this.$store.dispatch('UNSET_OVERLAY');
            console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      onRubricaBack(obj){
        console.log(obj);
        this.array_rubricas.push(obj.data);
        this.dialogForm = obj.modal;
        //console.log(this.array_rubricas);
        //console.log(this.array_rubricas.length);
      },
    }
  }
</script>